<template>
  <Popover @apply-show="show" @hide="hide">
    <div slot="popover" class="time-select" :class="{ small }">
      <CloseIcon v-if="!small" class="close" v-close-popover />
      <DrumRoll ref="hour" v-model.number="hour" :items="Array.from({ length: length }, (_, i) => startHour + i)" />
      <div class="separetor">:</div>
      <DrumRoll v-model="minute" :items="['00', '15', '30', '45']" :disabled="hour >= limit ? true : false" />
      <Button v-if="clearButton" class="clear" @click="clear">{{ small ? '未設定にする' : 'クリア' }}</Button>
    </div>
    <slot />
  </Popover>
</template>

<script>
import { padZero } from '@/utils/number'
import { toTimeObject } from '@/utils/time'
import Button from '@/components/atoms/Button'
import DrumRoll from '@/components/molecules/DrumRoll'
import Popover, { ClosePopover } from '@/components/molecules/Popover'
import CloseIcon from '@/components/icons/close'

let showCount = 0

/**
 * 時刻選択
 */
export default {
  name: 'TimeSelectPopover',
  components: {
    Button,
    DrumRoll,
    Popover,
    CloseIcon,
  },
  directives: {
    ClosePopover,
  },
  model: {
    prop: 'time',
    event: 'change',
  },
  props: {
    /** 時刻 (v-model) */
    time: String,
    /** 先頭の時 */
    startHour: { type: Number, default: 0 },
    /** クリアボタン */
    clearButton: Boolean,
    /** スモールモダール */
    small: Boolean,
    /** 選択時間数 */
    length: { type: Number, default: 24 },
    /** 時間制限 */
    limit: { type: Number, default: 30 },
  },
  data() {
    return {
      isShow: false,
      hour: null,
      minute: null,
    }
  },
  watch: {
    hour(value) {
      this.change()
      // 30時の場合は00分のみ選択
      if (value >= this.limit) this.minute = '00'
    },
    minute() {
      this.change()
    },
  },
  methods: {
    padZero,
    change() {
      if (this.hour === null || this.minute === null) return
      /**
       * 時刻変更 (v-model)
       * @event change
       * @type {string}
       */
      this.$emit('change', `${padZero(this.hour)}:${padZero(this.minute)}`)
    },
    reset() {
      const { hour = null, minute = null } = toTimeObject(this.time)
      this.hour = hour && +hour
      this.minute = minute
    },
    clear() {
      this.hour = null
      this.minute = null
      this.$emit('change', null)
    },
    show() {
      // iOS で DrumRoll の scrollIntoView によりガタつく場合があるのでその対処
      if (!showCount) {
        this.bodyOverflow = document.body.style.overflow
        document.body.style.overflow = 'hidden'
      }
      this.isShow = true
      showCount++

      this.reset()
      this.$refs.hour.scrollIntoView()
    },
    hide() {
      // iOS で DrumRoll の scrollIntoView によりガタつく場合があるのでその対処
      if (!this.isShow) return
      this.isShow = false
      showCount--
      if (!showCount) document.body.style.overflow = this.bodyOverflow

      this.reset()
    },
  },
}
</script>

<style lang="postcss" scoped>
.time-select {
  display: grid;
  font-size: 24px;
  font-weight: 600;
  grid-gap: 16px 0;
  grid-template-columns: 120px 16px 120px;
  padding: 36px 16px 16px;
  position: relative;
}

.separetor {
  align-items: center;
  display: flex;
  justify-content: center;
}

.close {
  fill: var(--light-gray);
  position: absolute;
  right: 10px;
  top: 8px;
}

.clear {
  color: var(--text-color);
  grid-column: 1 / -1;
  height: 48px;
  line-height: inherit;
  width: auto;
}

.small {
  font-weight: normal;
  grid-gap: 16px 0;
  grid-template-columns: 65px 16px 65px;
  justify-items: center;
  padding: 16px;

  .dram-roll {
    height: 191px;
    min-width: 64px;
  }

  >>> .item {
    font-size: 24px;
    height: 48px;
  }

  .clear {
    color: var(--moderate-blue);
    font-size: 14px;
    height: 40px;
    width: 122px;
  }
}
</style>
